/** @jsx React.DOM */
'use strict';

var React = require('react'),
    ItemTypes = require('./ItemTypes'),
    getEmptyImage = require('./getEmptyImage'),
    $__0=    React,PropTypes=$__0.PropTypes,
    $__1=     require('react-dnd'),DragDropMixin=$__1.DragDropMixin,DropEffects=$__1.DropEffects;

var Box = React.createClass({displayName: 'Box',
  mixins: [DragDropMixin],

  propTypes: {
    id: PropTypes.any.isRequired,
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  },

  configureDragDrop:function(registerType) {
    registerType(ItemTypes.BOX, {
      dragSource: {
        beginDrag:function(e) {
          return {
            effectAllowed: DropEffects.MOVE,
            dragPreview: getEmptyImage(),
            item: {
              id: this.props.id,
              startLeft: this.props.left,
              startTop: this.props.top,
              startPageX: e.pageX,
              startPageY: e.pageY
            }
          };
        }
      }
    });
  },

  render:function() {
    var $__0=    this.getDragState(ItemTypes.BOX),isDragging=$__0.isDragging,
        transform = ("translate3d(" + this.props.left + "px, " + this.props.top + "px, 0)");

    return (
      React.createElement("div", React.__spread({},  this.dragSourceFor(ItemTypes.BOX), 
           {style: {
            WebkitTransform: transform,
            transform: transform,
            opacity: isDragging ? 0.8 : 1,
            position: 'absolute',
            top: 0,
            left: 0,
            border: '1px dashed gray',
            padding: '0.5rem'
           }}), 
        this.props.children
      )
    );
  }
});

module.exports = Box;


/*****************
 ** WEBPACK FOOTER
 ** ./_drag-around-custom/Box.js
 ** module id = 132
 ** module chunks = 0
 **/